import React, { useState } from "react";
import CENModalUi from "./CENModalUi";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedCENId } from "../../store/cenSlice";

const CENModal = ({
  data,
  setShowModal,
  setCenSearch,
  cenSearch,
  setFiltersId,
  filtersId,
}) => {
  const dispatch = useDispatch();
  const selectedCENd = useSelector((state) => state.cen.selectedCEN);

  const [selectedCEN, setSelectedCEN] = useState(selectedCENd?.cenId); // State for the single selected CEN
  // Handler to select a single checkbox
  const handleCheckboxChange = (id) => {
    setSelectedCEN((prevSelected) => (prevSelected === id ? null : id));
  };

  const onSave = () => {
    if (selectedCEN) {
      const datad = data?.find((cen) => cen.id === selectedCEN);
      setFiltersId({...filtersId,cen_id:selectedCEN})
      dispatch(setSelectedCENId({ cenId: selectedCEN, name: datad?.name })); // Save selected ID to Redux
    }
    setShowModal(false);
  };

  return (
    <CENModalUi
      data={data}
      setShowModal={setShowModal}
      setCenSearch={setCenSearch}
      cenSearch={cenSearch}
      onSave={onSave}
      selectedCEN={selectedCEN}
      setSelectedCEN={setSelectedCEN}
      handleCheckboxChange={handleCheckboxChange}
    />
  );
};

export default CENModal;
